module.exports = __webpack_public_path__ + "img/FI.2ac14b6f.svg";